import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "SetupError", "Domain not valid for render step", config.defaultMessageId)